import { render } from "./Login.vue?vue&type=template&id=80c0e6b4&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=80c0e6b4&lang=less&scoped=true"

import exportComponent from "/Users/woniu/Desktop/woniu/web-tuiguangzu/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80c0e6b4"]])

export default __exports__